var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookLogoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1337_44671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 3.58206 12.4179 0 8 0C3.58206 0 0 3.58206 0 8C0 11.9927 2.92505 15.3025 6.75011 15.9032V10.313H4.71832V8H6.75011V6.2371C6.75011 4.23232 7.94487 3.12417 9.7719 3.12417C10.6472 3.12417 11.5629 3.28055 11.5629 3.28055V5.24933H10.5538C9.5604 5.24933 9.24989 5.86584 9.24989 6.49923V8H11.4684L11.114 10.313H9.24989V15.9032C13.075 15.3036 16 11.9938 16 8Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1145 10.3119L11.4689 7.99887H9.25032V6.4981C9.25032 5.86584 9.5597 5.24821 10.5542 5.24821H11.5634V3.27942C11.5634 3.27942 10.6476 3.12305 9.77233 3.12305C7.9453 3.12305 6.75053 4.23006 6.75053 6.23597V7.99887H4.71875V10.3119H6.75053V15.9021C7.15779 15.9662 7.57517 15.9989 8.00043 15.9989C8.42568 15.9989 8.84306 15.9651 9.25032 15.9021V10.3119H11.1145Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1337_44671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogoColor);
export default __webpack_public_path__ + "static/media/facebook-logo-color.ce239e40656030b091e0999da0b4e4d2.svg";
export { ForwardRef as ReactComponent };